/**
 * Constantes centralizadas para códigos de países
 * Sincronizado con el enum CountryCode del backend
 */
export const COUNTRIES = {
  AR: 'AR',
  DO: 'DO',
} as const;

export type CountryCode = typeof COUNTRIES[keyof typeof COUNTRIES];

/**
 * Enum de dominios por país
 */
export const COUNTRY_DOMAINS = {
  AR: 'panel.divix.net',
  DO: 'panel.divix.do',
} as const;

/**
 * Obtiene el código de país normalizado
 * Por defecto retorna AR si no hay país
 */
export function getCountryCode(countryCode: string | null | undefined): CountryCode {
  if (!countryCode) {
    return COUNTRIES.AR;
  }

  const upperCode = countryCode.toUpperCase();
  
  // Verificar si es un código válido
  if (upperCode === COUNTRIES.AR || upperCode === COUNTRIES.DO) {
    return upperCode as CountryCode;
  }

  // Por defecto retornar Argentina
  return COUNTRIES.AR;
}

/**
 * Obtiene el código de país basado en el dominio actual
 * @returns El código de país correspondiente al dominio, o AR por defecto
 */
export function getCountryCodeFromDomain(): CountryCode {
  const hostname = window.location.hostname;
  
  if (hostname === COUNTRY_DOMAINS.AR) {
    return COUNTRIES.AR;
  }
  
  if (hostname === COUNTRY_DOMAINS.DO) {
    return COUNTRIES.DO;
  }
  
  // Por defecto retornar Argentina
  return COUNTRIES.AR;
}

